module.exports = __webpack_public_path__ + "static/media/FitnessgirlNew.92e3015b.png";